export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9534.9b3d35c7.jpg";